import { connect } from 'react-redux';
import WorkDetails from './work_details';
import {
  setWorkSize, setFrame, removeFromCanvas, setNonGlare
} from '../../actions/canvas';
import { hide } from '../../actions/current_index';
import { addToCart } from '../../actions/cart';
import { showMoreLikeThis } from '../../actions/more_like_this';

const mapStateToProps = ({ workDetails, canvas: { works }, currentIndex }) => {
  const work = works[currentIndex] || {};
  const details = (work.workId ? workDetails[work.workId] : {}) || {};
  const framingOptions = work.workId
    ? ((details.workSizes || []).find((ws) => ws.id === work.workSizeId) || {}).options || []
    : [];
  return ({
    ...work,
    ...details,
    framingOptions,
    index: currentIndex
  });
};

export default connect(mapStateToProps, {
  setFrame, setWorkSize, hide, removeFromCanvas, addToCart, showMoreLikeThis, setNonGlare
})(WorkDetails);
